import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var X = function X() {
  return /*#__PURE__*/_jsxs("svg", {
    "aria-hidden": "true",
    height: "14",
    role: "presentation",
    viewBox: "0 0 13 14",
    width: "13",
    children: [/*#__PURE__*/_jsx("title", {
      children: "X"
    }), /*#__PURE__*/_jsx("path", {
      // eslint-disable-next-line max-len
      d: "m12.6922 1.38526c-.0277.02776-.0611.04996-.0888.07771-1.8263 1.82071-3.64697 3.64696-5.47323 5.47322-.0222.0222-.03885.04441-.07216.07216.03331.03886.06661.07216.09992.11102 1.81515 1.82071 3.63587 3.64693 5.45097 5.46763.0222.0222.0556.0444.0778.0667v.0277c-.1832.1832-.3609.3608-.544.544h-.0278c-.0277-.0333-.0555-.0722-.0833-.0999-1.8151-1.8096-3.63026-3.61923-5.44542-5.43438-.0333-.03331-.06661-.06106-.10547-.09992-.0333.03331-.0666.06106-.09991.08882-1.81515 1.81515-3.62476 3.62478-5.439914 5.43988-.033306.0333-.055506.0666-.083261.0999h-.027756c-.183181-.1831-.371915-.3608-.566197-.5495 1.892868-1.8929 3.774628-3.77463 5.645298-5.64529-1.87622-1.88732-3.74133-3.77464-5.595342-5.6453.17763-.17763.360811-.36081.538441-.538441 1.859561 1.842911 3.741331 3.713571 5.623091 5.578681 1.87067-1.87066 3.75244-3.75242 5.64534-5.645292.2053.205385.3885.394112.5662.577292v.02776z",
      fill: "#202020"
    })]
  });
};

export default X;